import * as Pathway from './Pathway.ts';
export * from './Pathway.ts';

/**
 * Searches up the directory tree from the current working directory to find a path that matches the test function.
 * @param params - Configuration object with test function and optional skip function
 * @returns The matching Pathway instance, or undefined if not found
 */
export const findUp = (params: Pathway.findParams) => {
	return Pathway.create(process.cwd()).findUp(params);
};

/**
 * Searches up the directory tree from the current working directory. Throws if not found.
 * @param params - Configuration object with test function and optional skip function
 * @returns The matching Pathway instance
 * @throws {TargetPathNotFoundError} When no matching path is found
 */
export const findUpStrict = (params: Pathway.findParams) => {
	return Pathway.create(process.cwd()).findUpStrict(params);
};

/**
 * Finds the nearest directory containing a package.json file.
 * @param params - Optional configuration to customize the search behavior
 * @returns The directory containing package.json, or undefined if not found
 */
export const packageDir = (params?: Partial<Pathway.findParams>) => {
	return Pathway.create(process.cwd()).packageDir(params);
};

/**
 * Finds the nearest directory containing a package.json file. Throws if not found.
 * @param params - Optional configuration to customize the search behavior
 * @returns The directory containing package.json
 * @throws {TargetPathNotFoundError} When no package.json is found
 */
export const packageDirStrict = (params?: Partial<Pathway.findParams>) => {
	return Pathway.create(process.cwd()).packageDirStrict(params);
};
